// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingSpinner_loading__1k7fl","spinner":"LoadingSpinner_spinner__1_IZN","spin":"LoadingSpinner_spin__2z_9P"};